export default __webpack_public_path__ + "static/media/sc17.efa51d45.jpg";